import api from '../../lib/api';
import type { FetchSgCalendarParams, SgCalendarEvent, SgCalendarMeta } from './types';

export async function fetchSgCalendar(
  params?: FetchSgCalendarParams,
): Promise<{ events: SgCalendarEvent[]; meta: SgCalendarMeta }> {
  const { data } = await api.get<{ data: SgCalendarEvent[]; meta: SgCalendarMeta }>(
    'sg-calendar',
    { params },
  );
  return { events: data.data, meta: data.meta };
}
